/**
 * ScreenerContributionChart — cumulative realized P&L (₹) by screener over
 * month buckets, as a diverging stacked bar (positives above 0, negatives
 * below). Surfaces which screener carried the run.
 *
 * Props:
 *   data    from analytics.cumulativeContributionByScreener(windows)
 *           {buckets:[YYYY-MM], series:[{name, color, values:[cum ₹]}]}
 *   height  number  SVG height (default 240)
 */

import { Bar, BarChart, Legend, Tooltip, XAxis, YAxis } from "recharts";

const CHART_COLORS = [
  '#3b82f6', // Blue
  '#10b981', // Green
  '#f59e0b', // Yellow
  '#ef4444', // Red
  '#8b5cf6', // Purple
  '#ec4899', // Pink
  '#06b6d4', // Cyan
  '#f97316', // Orange
  '#14b8a6', // Teal
  '#64748b'  // Slate
];

function money(v) {
  const a = Math.abs(v);
  if (a >= 1e7) return `${(v / 1e7).toFixed(1)}Cr`;
  if (a >= 1e5) return `${(v / 1e5).toFixed(1)}L`;
  if (a >= 1e3) return `${(v / 1e3).toFixed(0)}k`;
  return `${v.toFixed(0)}`;
}

export default function ScreenerContributionChart({ data, height = 240 }) {
  if (!data || !data.buckets?.length || !data.series?.length) return null;
  const { buckets, series } = data;

  const chartdata = []
  buckets.forEach((b, bi) => {
    const row = {'month': b}
    series.forEach((s)=> {
      row[s.name] = s.values[bi]
    })
    chartdata.push(row)
  });

  return (
    <div className="flex flex-col gap-3 text-sm">
      <BarChart
        style={{ width: '100%', aspectRatio: 1.618 }}
        responsive
        margin={{
          top: 20,
          right: 0,
          left: 0,
          bottom: 5,
        }}
        data={chartdata}
        stackOffset="sign"
      >
        <XAxis dataKey="month" niceTicks="snap125" 
          tick={{fill: 'hsl(var(--foreground))'}}
        />
        <YAxis width="auto" niceTicks="snap125" 
          tickFormatter={(value)=>money(value)}
          domain={['dataMin', 'dataMax']}
          tick={{fill: 'hsl(var(--foreground))'}}
        />
        <Tooltip 
          labelStyle={{ color: 'hsl(var(--foreground))' }}
          contentStyle={{background: 'hsl(var(--background))', borderRadius: '8px', border: 'none', boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)' }}
        />
        <Legend />
        {series.map((s, si)=> {
          return <Bar dataKey={s.name} 
            stackId="a" fill={CHART_COLORS[si]} 
            formatter={(value)=>money(value)}
            />
        })}
      </BarChart>
    </div>
  );
}
